exports = module.exports = require("../../../../../node_modules/_css-loader@0.25.0@css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".m-smiley-tip {\n  position: absolute;\n  bottom: 100px;\n  right: 12px;\n  background-color: #FFDB80;\n  border-radius: 20px 20px 4px 20px;\n  padding: 2px;\n  z-index: 9; }\n  .m-smiley-tip .smiley-wrap {\n    background: #fff;\n    border-radius: 20px 20px 4px 20px; }\n    .m-smiley-tip .smiley-wrap img {\n      width: 100px;\n      height: 100px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/_css-loader@0.25.0@css-loader?{}!./node_modules/_sass-loader@4.0.2@sass-loader?{"sourceMap":true}!./node_modules/_postcss-loader@1.3.3@postcss-loader?{"sourceMap":true}!./src/component/view/footer/smileytip/style.scss
// module id = 185
// module chunks = 0 1